module.exports = __webpack_public_path__ + "media/components/videos_internal/video_play-bff25689f6934b073a83135dfe44a043.png";